<script lang="ts" setup>
defineProps({
  clickable: {
    default: false,
    type: Boolean,
  },
})

const emit = defineEmits<{
  click: []
}>()

function onClick() {
  emit('click')
}
</script>

<template>
  <div
    class="relative size-4 transform rounded-full bg-indigo-800 ring-2 ring-white transition"
    :class="{
      'cursor-pointer hover:scale-125 hover:shadow-lg active:scale-95': clickable,
      'cursor-default': !clickable,
    }"
    @click="onClick"
  />
</template>
